// extracted by mini-css-extract-plugin
export default {"List":"rDGVNwgLzKIbRsk0o5gg","Item":"_h6l0gIwlyjd_40OjSKx"};